import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Flame } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const dashHref =
    user?.role === "cook" ? "/cook" :
    user?.role === "owner" ? "/owner" :
    user?.role === "admin" ? "/admin" : "/";

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 bg-black/90 backdrop-blur-md border-b hairline"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link data-testid="nav-logo" to="/" className="flex items-center gap-2">
          <Flame size={22} className="text-[#FF3B30]" strokeWidth={2.5} />
          <span className="font-display text-xl font-black tracking-tighter">KITCHENSHARE</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <Link data-testid="nav-browse" to="/browse" className="tick-label hover:text-white transition-colors">Browse</Link>
          <Link data-testid="nav-find-chef" to="/find-a-chef" className="tick-label hover:text-white transition-colors">Find a Chef</Link>
          <Link data-testid="nav-list-kitchen" to="/list-your-kitchen" className="tick-label hover:text-white transition-colors">List Kitchen</Link>
          <Link data-testid="nav-corporate" to="/corporate" className="tick-label hover:text-white transition-colors">Corporate</Link>
          {user?.role === "cook" && (
            <Link data-testid="nav-my-profile" to="/cook/profile" className="tick-label hover:text-white transition-colors">My Profile</Link>
          )}
          {user && (
            <Link data-testid="nav-dashboard" to={dashHref} className="tick-label hover:text-white transition-colors">Dashboard</Link>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {!user ? (
            <>
              <Link data-testid="nav-login" to="/login" className="tick-label hover:text-white">Sign in</Link>
              <Link data-testid="nav-register" to="/register" className="btn-signal">Get started</Link>
            </>
          ) : (
            <>
              <span data-testid="nav-user" className="hidden sm:block tick-label">{user.name}</span>
              <button data-testid="nav-logout" onClick={() => { logout(); nav("/"); }} className="btn-outline">Logout</button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
